import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Loader } from 'lucide-react';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { store, persistor } from './store/store';
import { clearTokens } from './store/tokensSlice';

function FullScreenLoader() {
    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            zIndex: 9999,
            backdropFilter: 'blur(4px)',
        }}>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '20px',
            }}>
                <Loader size={50} color="#3498db" style={{
                    animation: 'spin 1s linear infinite',
                }}/>

                <p style={{
                    margin: 0,
                    fontSize: '16px',
                    color: '#333',
                    fontWeight: '500',
                }}>
                    Ładowanie aplikacji...
                </p>
            </div>

            <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
        </div>
    );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
        <PersistGate
          loading={<FullScreenLoader />}
          persistor={persistor}
          onBeforeLift={async () => {
            const { accessToken, refreshToken, accessTokenExpiration, refreshTokenExpiration } = store.getState().tokens;
            const now = Date.now();

            const toMs = (value) => {
              if (!value) return null;
              const ms = new Date(value).getTime();
              return Number.isNaN(ms) ? null : ms;
            };

            const accessExpMs = toMs(accessTokenExpiration);
            const refreshExpMs = toMs(refreshTokenExpiration);

            const hasAnyToken = !!accessToken || !!refreshToken;
            const isAccessValid = !!accessToken && !!accessExpMs && accessExpMs > now;
            const isRefreshValid = !!refreshToken && !!refreshExpMs && refreshExpMs > now;

            if (hasAnyToken && !isAccessValid && !isRefreshValid) {
              store.dispatch(clearTokens());
              await persistor.flush();
              window.location.replace('/login');
            }
          }}
        >
            <App />
        </PersistGate>
    </Provider>
  </React.StrictMode>
);
